module.exports = __webpack_public_path__ + "img/phone-black.1cfc8050.svg";